import React from 'react';
import { Modal } from 'antd';
import SignatureModalContent from '../InsertSignatureUsersModal/SignatureModalContent/signatureModalContent';

const LexicalSignatureModal = ({ visible, onClose }) => {
    return (
        <Modal
            title="Document Signature"
            visible={visible}
            onCancel={onClose}
            footer={null}
            zIndex={9999}
            style={{ height: 'max-content' }}
            destroyOnClose
        >
            <SignatureModalContent setIsModalVisible={onClose} />
        </Modal>
    );
};

export default LexicalSignatureModal;